export const ROLE_STORE = 'ROLE_STORE';
export const ROLE_UPDATE = 'ROLE_UPDATE';
export const ROLE_DESTROY = 'ROLE_DESTROY';
